module.exports = __webpack_public_path__ + "static/asic-auto-tune-20bb53dcfd65d07703a761b85b402d21.gif";